<template>
    <div ref="container"
        :class="[
            'cz2__client-image-editor',
            'cz2__client-layout-editor',
            {
                'cz2__client-image-loading': false,
                'cz2__client-layout-editor--disabled': !enabled,
                'cz2__client-layout-editor--square': squareHandles,
            }
        ]">

        <!-- Replaced with dynamic element
            <canvas ref="canvas"></canvas>
        -->

        <portal :to="portalName" :order="1">
            <div v-show="placement && (rotateable || sizeable)" ref="sizeborder"
                :key="index + '-' + placement.placement.code + '-sizeborder'"
                :class="[
                    'cz2__client-image-sizeborder',
                    {
                        'cz2__client-image-sizeborder--fullwrap': fullWrap,
                    }
                ]">
            </div>

            <div v-show="placement && (rotateable || sizeable)" ref="sizeguide"
                :key="index + '-' + placement.placement.code + '-sizeguide'"
                :class="[
                    'cz2__client-image-sizeguide',
                    'cz2__client-image-interact-inner',
                    {
                        'cz2__client-image-sizeguide--enabled': enabled,
                        'cz2__client-image-sizeguide--square': squareHandles,
                        'cz2__client-image-sizeguide--text': textHandles,
                    }
                ]">
                <div v-show="moveable" ref="movehandle"
                    :class="[
                        'cz2__client-image-move-handle',
                        { 'cz2__client-image-move-handle--enabled': enabled },
                    ]"
                ></div>
                <div v-show="tooltipVisible && moveable" ref="moveguide" class="cz2__client-image-move-guide">
                    <span class="cz2__client-image-moveguide-tooltip">
                        <span>{{$t('DRAG_MOVE')}}</span>
                    </span>
                </div>
                <button ref="sizeguidehandle" class="cz2__client-image-sizehandle">
                    <transition name="fade-sizeguide-tooltip">
                        <span v-show="tooltipVisible" class="cz2__client-image-sizeguide-tooltip">
                            <template v-if="rotateable">
                                <span v-if="sizeable">{{$t('DRAG_SCALE_ROTATE')}}</span>
                                <span v-else>{{$t('DRAG_ROTATE')}}</span>
                            </template>
                            <template v-else>
                                <span v-if="sizeable">{{$t('DRAG_SCALE')}}</span>
                            </template>
                        </span>
                    </transition>
                </button>

                <button ref="widthhandle-l" class="cz2__client-image-widthonlyhandle cz2__client-image-widthonlyhandle-l">
                </button>

                <button ref="widthhandle-r" class="cz2__client-image-widthonlyhandle cz2__client-image-widthonlyhandle-r">
                </button>

                <button ref="sizeguidehandle-lt" class="cz2__client-image-sizeonlyhandle cz2__client-image-sizeonlyhandle-lt">
                </button>

                <button ref="sizeguidehandle-rt" class="cz2__client-image-sizeonlyhandle cz2__client-image-sizeonlyhandle-rt">
                </button>

                <button ref="sizeguidehandle-lb" class="cz2__client-image-sizeonlyhandle cz2__client-image-sizeonlyhandle-lb">
                </button>

                <button ref="sizeguidehandle-rb" class="cz2__client-image-sizeonlyhandle cz2__client-image-sizeonlyhandle-rb">
                </button>

                <button ref="rotatehandle" class="cz2__client-image-rotatehandle">
                </button>
            </div>
        </portal>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__client-image-editor {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            overflow: hidden;

            transform: translate3d(0, 0, 0);

            canvas {
            }
        }

        .cz2__client-image-sizeborder {
            position: absolute;

            left: 50%;
            top: 50%;

            border: 2px solid #fff;
            box-sizing: border-box;
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);

            &.cz2__client-image-sizeborder--fullwrap {
                border-left: none;
                border-right: none;
                border-top-color: rgba(0, 0, 0, 0);
                border-bottom-color: rgba(0, 0, 0, 0);

                box-shadow: none;

                margin-left: 0;

                &:before {
                    content: '';

                    position: absolute;

                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 2px;

                    background: #fff;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }

                &:after {
                    content: '';

                    position: absolute;

                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 2px;

                    background: #fff;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }
            }

            pointer-events: none;

            box-sizing: content-box;
            margin-left: -2px;
            margin-top: -2px;

            z-index: 1;
        }

        .cz2__client-image-sizeguide {
            position: absolute;

            left: 50%;
            top: 50%;

            width: $guide-size-small;
            height: $guide-size-small;

            z-index: 2;

            &.cz2__client-image-sizeguide--text {
                // margin-top: 10px;
            }

            @include respond-above(sm) {
                width: $guide-size;
                height: $guide-size;
            }

            transform: translate(-50%, -50%);

            border-radius: 300px;

            pointer-events: none;

            visibility: hidden;
            opacity: 0;

            transition: visibility $transition-fast ease-out, opacity $transition-fast ease-out, border $transition-fast ease-out;

            &.cz2__client-image-sizeguide--square {
                border-radius: 0;

                &:before {
                    content: '';

                    position: absolute;

                    left: 0px;
                    top: 0px;

                    width: calc(100% + 0px);
                    height: calc(100% + 0px);

                    border: 2px solid rgba(255, 255, 255, 1);
                    filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));

                    pointer-events: none;
                }

                &.cz2__client-image-sizeguide--text {
                    &:before {
                        // left: 0px;
                        // top: -10px;

                        // width: calc(100% + 0px);
                        // height: calc(100% + 20px);
                    }
                }

                .cz2__client-image-widthonlyhandle {
                    display: block;
                    position: absolute;

                    cursor: col-resize;

                    height: 100%;
                    width: 20px;

                    pointer-events: auto;
                    touch-action: none;

                    outline: none;

                    &:focus {
                        outline: none;
                    }

                    &.cz2__client-image-widthonlyhandle-l {
                        left: -20px;
                    }

                    &.cz2__client-image-widthonlyhandle-r {
                        right: -20px;
                    }
                }

                .cz2__client-image-sizeonlyhandle {
                    display: block;
                }

                .cz2__client-image-rotatehandle {
                    display: block;
                }

                .cz2__client-image-sizehandle {
                    display: none;
                }

                .cz2__client-image-move-handle {
                    width: 100%;
                    height: 100%;

                    &:before {
                        display: none;
                    }
                }

                .cz2__client-image-moveguide-tooltip {
                    display: none;
                }
            }

            &.cz2__client-image-sizeguide--enabled {
                visibility: visible;
                opacity: 1;
            }

            &.cz2__client-image-sizeguide--active {
                .cz2__client-image-sizeguide-tooltip {
                    visibility: hidden;
                    opacity: 0;
                }

                .cz2__client-image-moveguide-tooltip {
                    visibility: hidden;
                    opacity: 0;
                }

                .cz2__client-image-move-handle {
                    &:before {
                        opacity: 0.3;
                    }
                }

                .cz2__client-image-sizehandle {
                    &:after {
                        opacity: 0.3;
                    }
                }
            }

            .cz2__client-image-move-handle {
                position: absolute;

                left: 50%;
                top: 50%;

                width: 80px;
                height: 80px;

                transform: translate(-50%, -50%);

                cursor: pointer;

                touch-action: none;

                &:before {
                    content: '';

                    position: absolute;

                    width: 20px;
                    height: 20px;
                    border-radius: 20px;

                    left: 50%;
                    top: 50%;

                    transform: translate(-50%, -50%);

                    background: #067ca4;
                    border: 2px solid #fff;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);

                    transition: opacity $transition-fast ease-out;

                    pointer-events: none;
                }

                &.cz2__client-image-move-handle--enabled {
                    pointer-events: auto;
                }
            }

            .cz2__client-image-move-guide {
                position: absolute;

                right: 50%;
                top: 50%;

                width: 1px;
                height: 1px;
            }

            .cz2__client-image-moveguide-tooltip {
                position: absolute;

                right: 0;
                top: 10px;

                transform: translate(20px, 15px);

                padding: 5px 10px;

                background: #fff;
                color: #000;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);

                font-family: $font-main;
                font-size: 10px;

                white-space: nowrap;

                transition: visibility $transition-fast ease-out, opacity $transition-fast ease-out;

                pointer-events: none;

                &:after {
                    content: '';

                    position: absolute;

                    top: -5px;
                    right: 15px;

                    width: 0;
                    height: 0;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;

                    border-bottom: 5px solid #fff;
                }
            }

            .cz2__client-image-rotatehandle {
                position: absolute;

                display: none;

                width: 20px;
                height: 20px;

                z-index: 1;

                margin-left: -10px;
                margin-top: -10px;

                left: 50%;
                top: calc(100% + 30px);

                touch-action: none;

                &:after {
                    content: '';

                    display: block;
                    position: absolute;

                    width: 30px;
                    height: 30px;

                    border-radius: 20px;

                    left: 50%;
                    top: 50%;

                    transform: translate(-50%, -50%);

                    background: #067ca4 url(../assets/rotate@2x.png) no-repeat center/contain;
                    border: 2px solid #ffffff;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }

                pointer-events: auto;
                cursor: grab;

                &:focus {
                    outline: none;
                }
            }

            &.cz2__client-image-sizeguide--text {
                // .cz2__client-image-sizeonlyhandle {
                //     &.cz2__client-image-sizeonlyhandle-lt {
                //         margin-top: -10px;
                //     }

                //     &.cz2__client-image-sizeonlyhandle-rt {
                //         margin-top: -10px;
                //     }

                //     &.cz2__client-image-sizeonlyhandle-lb {
                //         margin-top: 10px;
                //     }

                //     &.cz2__client-image-sizeonlyhandle-rb {
                //         margin-top: 10px;
                //     }
                // }
            }

            .cz2__client-image-sizeonlyhandle {
                position: absolute;

                display: none;

                width: 40px;
                height: 40px;

                z-index: 1;

                touch-action: none;

                &.cz2__client-image-sizeonlyhandle-lt {
                    left: calc(0% - 36px);
                    top: calc(0% - 36px);

                    &:before, &:after {
                        left: calc(100% - 4px);
                        top: calc(100% - 3px);
                    }

                    cursor: nw-resize;
                }

                &.cz2__client-image-sizeonlyhandle-rt {
                    left: calc(100% - 4px);
                    top: calc(0% - 36px);

                    &:before, &:after {
                        left: calc(0% + 4px);
                        top: calc(100% - 3px);
                    }

                    cursor: ne-resize;
                }

                &.cz2__client-image-sizeonlyhandle-lb {
                    left: calc(0% - 36px);
                    top: calc(100% - 4px);

                    &:before, &:after {
                        left: calc(100% - 4px);
                        top: calc(0% + 3px);
                    }

                    cursor: sw-resize;
                }

                &.cz2__client-image-sizeonlyhandle-rb {
                    left: calc(100% - 4px);
                    top: calc(100% - 4px);

                    &:before, &:after {
                        left: calc(0% + 4px);
                        top: calc(0% + 3px);
                    }

                    cursor: se-resize;
                }

                touch-action: none;

                &:after {
                    content: '';

                    display: block;
                    position: absolute;

                    width: 12px;
                    height: 12px;

                    border-radius: 10px;

                    left: 50%;
                    top: 50%;

                    // margin-left: -2px;
                    // margin-top: -2px;

                    transform: translate(-50%, -50%);

                    // background: #ff0000;

                    background: #067ca4;
                    border: 2px solid #ffffff;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }

                &.cz2__client-image-sizeonlyhandle--outside {
                    &:after {
                        background: #f00;

                        border-radius: 0;
                    }
                }

                /*
                &:before {
                    content: '';

                    display: block;
                    position: absolute;

                    width: 10px;
                    height: 10px;

                    // border-radius: 10px;

                    left: 50%;
                    top: 50%;

                    margin-left: 2px;
                    margin-top: 2px;

                    transform: translate(-50%, -50%);

                    z-index: 2;

                    background: #fff;
                    border: 2px solid #ff0000;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }
                */

                pointer-events: auto;
                cursor: move;

                &:focus {
                    outline: none;
                }
            }

            .cz2__client-image-sizehandle {
                position: absolute;

                width: 80px;
                height: 80px;

                z-index: 1;

                margin-left: -40px;
                margin-top: -40px;

                left: 50%;
                top: 50%;

                transform: translate($guide-size-small / 2, 0);

                touch-action: none;

                @include respond-above(sm) {
                    transform: translate($guide-size / 2, 0);
                }

                &:after {
                    content: '';

                    display: block;
                    position: absolute;

                    width: 20px;
                    height: 20px;

                    border-radius: 20px;

                    left: 50%;
                    top: 50%;

                    transform: translate(-50%, -50%);

                    background: #067ca4;
                    border: 2px solid #ffffff;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
                }

                pointer-events: auto;
                cursor: move;

                &:focus {
                    outline: none;
                }

                .cz2__client-image-sizeguide-tooltip {
                    position: absolute;

                    left: 20px;
                    bottom: 65px;

                    padding: 5px 10px;

                    background: #fff;
                    color: #000;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);

                    font-family: $font-main;
                    font-size: 10px;

                    white-space: nowrap;

                    transition: visibility $transition-fast ease-out, opacity $transition-fast ease-out;

                    pointer-events: none;

                    &:after {
                        content: '';

                        position: absolute;

                        bottom: -5px;
                        left: 15px;

                        width: 0;
                        height: 0;
                        border-left: 5px solid transparent;
                        border-right: 5px solid transparent;

                        border-top: 5px solid #fff;
                    }
                }
            }
        }

        .fade-sizeguide-tooltip-enter-active, .fade-sizeguide-tooltip-leave-active {
            transition: opacity .25s;
        }

        .fade-sizeguide-tooltip-enter, .fade-sizeguide-tooltip-leave-to {
            opacity: 0;
        }

        .cz2__client-image-editor.cz2__client-layout-editor {
            opacity: 1;

            visibility: visible;
        }
    }
</style>

<script>
    import interact from 'interactjs';

    import webp from './webp';

    import * as constants from '../constants';

    import designArea from '../utilities/designArea';
    import extent from '../utilities/extent';
    import isFilled from '../utilities/isFilled';

    import * as renderHelper from './renderHelper';

    const TRACE = true;

    // eslint-disable-next-line
    function trace(v) {
        if (TRACE) {
            // eslint-disable-next-line
            console.log(v);
        }
    }

    export default {
        props: {
            index: Number,
            controller: Object,
            view: Object,
            frame: Number,
            placement: Object,
            portalName: String,
            enabled: Boolean,
            squareHandles: Boolean,
            layerScale: Number,
            showBorders: Boolean,
            bordersOnly: Boolean,
            secondary: Boolean,
        },
        data() {
            return {
                progressX: null,
                progressY: null,
                progressScale: null,
                progressRotate: null,

                moveable: false,
                sizeable: false,
                rotateable: false,

                tooltipVisible: true,

                active: false,
            };
        },
        computed: {
            textHandles() {
                if (this.placement) {
                    return this.placement.placement.code.includes(constants.PLACEMENT_TEXT);
                }

                return false;
            },

            fullWrap() {
                if (this.controller == null) {
                    return false;
                }

                return this.controller.blueprint.custom['v-design-wrap'] === 'true';
            },
        },
        watch: {
            controller: {
                handler(newValue, oldValue) {
                    // Rebind controller events.
                    if (oldValue) {
                        Object.keys(this.controllerEvents).forEach((e) => {
                            oldValue.off(e, this.controllerEvents[e]);
                        });
                    }

                    if (newValue) {
                        Object.keys(this.controllerEvents).forEach((e) => {
                            newValue.off(e, this.controllerEvents[e]);
                        });
                    }

                    Object.keys(this.controllerEvents).forEach((e) => {
                        newValue.on(e, this.controllerEvents[e]);
                    });

                    this.createImage();
                },
                deep: false,
            },

            view() {
                this.selectView();
            },

            enabled() {
                this.$nextTick(() => {
                    this.enableInteract();
                });

                // Clear warnings.
                if (!this.enabled) {
                    this.$store.dispatch('setDesignOutside', false);
                }

                this.paint();
            },

            showBorders() {
                this.paint();
            },
        },
        beforeCreate() {
            this.controllerEvents = {
                stateChanged: (e) => this.onStateChanged(e),
                repaint: (e) => this.onRepaint(e),
            };
        },
        destroy() {
            // Stop listening to controller events.
            if (this.controller) {
                Object.keys(this.controllerEvents).forEach((e) => {
                    this.controller.off(e, this.controllerEvents[e]);
                });
            }
        },
        mounted() {
            Object.keys(this.controllerEvents).forEach((e) => {
                this.controller.on(e, this.controllerEvents[e]);
            });

            this.createImage();

            this.$nextTick(() => {
                this.enableInteract();
            });

            window.addEventListener('resize', () => this.resize());

            this.sizeTicker = setInterval(() => {
                this.checkSize();
            }, 500);
        },
        beforeDestroy() {
            if (this.sizeTicker) {
                clearInterval(this.sizeTicker);
            }
        },
        updated() {
            this.$nextTick(() => {
                this.enableInteract();
            });
        },
        beforeUpdate() {
            this.removeInteract();
        },
        methods: {
            // Provide a proxy to the API object and listen to important events.
            createImage() {
                this.resize();

                if (this.controller) {
                    this.selectView();
                }
            },

            /**
             * Selects the current view.
             */
            selectView() {
                // eslint-disable-next-line
                if (this.placement) {
                    this.loadImage();
                }

                // Enable interactions if the component was rendered already.
                if (this.$refs.sizeguide) {
                    this.enableInteract();
                }
            },

            /**
             * Resize canvas.
             */
            resizeCanvas(container, canvas) {
                const width = container.clientWidth;
                const height = container.clientHeight;

                canvas.width = width * 2;
                canvas.height = height * 2;
                canvas.style.width = `${width}px`;
                canvas.style.height = `${height}px`;
            },

            /**
             * Resize editor.
             */
            resize() {
                if (this.resizeTimer != null) {
                    clearTimeout(this.resizeTimer);
                }

                this.resizeTimer = setTimeout(() => {
                    const { container } = this.$refs;

                    if (container) {
                        const canvas = container.querySelector('canvas');

                        if (canvas != null) {
                            this.resizeCanvas(container, canvas);

                            this.paint();
                        }
                    }
                }, 50);
            },

            /**
             * Check if screen size changed.
             */
            checkSize() {
                const { container } = this.$refs;

                if (container) {
                    const width = container.clientWidth;

                    if (this.lastWidth == null) {
                        this.lastWidth = width;
                    } else if (this.lastWidth !== width) {
                        this.lastWidth = width;

                        this.resize();
                    }
                }
            },

            /**
             * Loads and caches the image to be edited.
             */
            loadImage() {
                if (this.placement != null && this.view != null && this.frame != null) {
                    if (this.placement.placement.code === 'CBKImage1' && this.view.code === 'FrontTopSwapped') {
                        // eslint-disable-next-line
                        var a =4;
                    }

                    this.image = this.makeLoader(this.image);

                    const { code } = this.placement.placement;

                    const viewSettings = this.view.placements.find((p) => p.code === code);

                    let mask = null;

                    const component = this.controller.selectedAtPlacement(code);

                    if (component.custom.mask) {
                        mask = component.custom.mask;
                    }

                    if (viewSettings && viewSettings.custom && viewSettings.custom.mask) {
                        mask = viewSettings.custom.mask;
                    }

                    if (mask) {
                        // eslint-disable-next-line
                        const maskUrl = this.controller.baseFrameUrl()
                            + 'src='
                            + this.controller.mapImageName(
                                this.controller.imageName(mask, null, this.view, this.view.frameLow),
                                this.controller.blueprint.imageMapping,
                                {
                                    background: true,
                                },
                            );

                        this.mask = this.makeLoader(maskUrl, this.mask);
                    } else {
                        if (this.mask) {
                            this.mask.cancelLoader();
                        }
                        this.mask = null;
                    }

                    let viewMask = null;

                    if (!viewMask) {
                        if (viewSettings && viewSettings.custom && viewSettings.custom.group) {
                            const sourceName = `g!${viewSettings.custom.group}`;

                            const useGroup = this.view.placements.find((p) => p.custom && p.custom.source === sourceName);

                            if (useGroup && useGroup.custom && useGroup.custom.mask) {
                                viewMask = useGroup.custom.mask;
                            }
                        }
                    }

                    if (viewMask) {
                        // eslint-disable-next-line
                        const maskUrl = this.controller.baseFrameUrl()
                            + 'src='
                            + this.controller.mapImageName(
                                this.controller.imageName(viewMask, null, this.view, this.view.frameLow),
                                this.controller.blueprint.imageMapping,
                                {
                                    background: true,
                                },
                            );

                        this.viewMask = this.makeLoader(maskUrl, this.viewMask);
                    } else {
                        if (this.viewMask) {
                            this.viewMask.cancelLoader();
                        }
                        this.viewMask = null;
                    }

                    let { overlay } = this.placement.placement.custom;

                    if (!overlay) {
                        overlay = this.view && this.view.custom && this.view.custom.overlay;
                    }

                    if (!overlay) {
                        if (viewSettings && viewSettings.custom && viewSettings.custom.group) {
                            const sourceName = `g!${viewSettings.custom.group}`;

                            const useGroup = this.view.placements.find((p) => p.custom && p.custom.source === sourceName);

                            if (useGroup && useGroup.custom && useGroup.custom.overlay) {
                                overlay = useGroup.custom.overlay;
                            }
                        }
                    }

                    if (overlay) {
                        // eslint-disable-next-line
                        const overlayUrl = this.controller.baseFrameUrl()
                            + 'src='
                            + this.controller.mapImageName(
                                this.controller.imageName(overlay, null, this.view, this.view.frameLow),
                                this.controller.blueprint.imageMapping,
                                {
                                    background: true,
                                },
                            );

                        this.overlay = this.makeLoader(overlayUrl, this.overlay);
                    } else {
                        if (this.overlay) {
                            this.overlay.cancelLoader();
                        }
                        this.overlay = null;
                    }
                }
            },

            /**
             * Creates image loader.
             */
            makeLoader(useUrl, otherLoader) {
                const self = this;

                const { code } = this.placement.placement;

                const component = this.controller.selectedAtPlacement(code);

                if (!isFilled(component)) {
                    return {
                        url: null,
                        ready: true,
                        error: true,
                        image: new Image(),

                        cancelLoader() {},
                    };
                }

                const options = {
                    onlyPlacement: code,
                };

                if (this.view && this.view.placements) {
                    const viewSettings = this.view.placements.find((p) => p.code === code);

                    if (viewSettings && viewSettings.custom && viewSettings.custom.group) {
                        options.noBackground = true;
                    }
                }

                let url = this.controller.makeFrameUrl(this.view, this.controller.state, this.frame, options);

                if (typeof useUrl === 'string') {
                    url = useUrl;
                }

                if (url.includes('?')) {
                    url += '&fmt=webp';
                } else {
                    url += '?fmt=webp';
                }

                if (this.layerScale !== 1) {
                    if (url.includes('?')) {
                        url += `&rscale=${this.layerScale.toFixed(2)}`;
                    } else {
                        url += `?rscale=${this.layerScale.toFixed(2)}`;
                    }
                }

                if (otherLoader != null && typeof otherLoader === 'object') {
                    if (otherLoader.url === url) {
                        return otherLoader;
                    }

                    otherLoader.cancelLoader();
                }

                if (useUrl != null && typeof useUrl === 'object') {
                    if (useUrl.url === url) {
                        return useUrl;
                    }

                    useUrl.cancelLoader();
                }

                const loader = {
                    url,
                    ready: false,
                    error: false,
                    cancelled: false,
                    image: new Image(),
                    xhr: new XMLHttpRequest(),

                    cancelLoader() {
                        if (this.xhr) {
                            this.xhr.abort();
                            this.cancelled = true;
                        }
                    },
                };

                loader.personalizationWidth = component.custom['personalization-width'];
                loader.personalizationHeight = component.custom['personalization-height'];

                loader.xhr.onload = function onXhrLoad() {
                    if (loader.cancelled) {
                        return;
                    }

                    let notes = loader.xhr.getResponseHeader('X-Notes');

                    const isMonogram = self.placement.placement.code.startsWith(constants.PLACEMENT_MONOGRAM);

                    if (!self.secondary && notes) {
                        try {
                            notes = JSON.parse(notes);

                            const realSize = notes.find((n) => n.type === 'TextBox');
                            if (realSize && realSize.note) {
                                const bounds = realSize.note.split(',').map((x) => parseFloat(x.trim()));

                                // eslint-disable-next-line
                                loader.textRealLeft = bounds[0];
                                // eslint-disable-next-line
                                loader.textRealTop = bounds[1];
                                // eslint-disable-next-line
                                loader.textRealWidth = bounds[2];
                                // eslint-disable-next-line
                                loader.textRealHeight = bounds[3];

                                self.placement.placement.custom['personalization-bbox-left'] = bounds[0].toString();
                                self.placement.placement.custom['personalization-bbox-top'] = bounds[1].toString();
                                self.placement.placement.custom['personalization-bbox-width'] = bounds[2].toString();
                                self.placement.placement.custom['personalization-bbox-height'] = bounds[3].toString();
                                self.placement.placement.custom['personalization-bbox-base-width'] = loader.personalizationWidth;
                                self.placement.placement.custom['personalization-bbox-base-height'] = loader.personalizationHeight;
                            }

                            const size = notes.find((n) => n.type === 'TextBounds');
                            if (size && size.note) {
                                const bounds = size.note.split(',').map((x) => parseFloat(x.trim()));

                                // Remove descent
                                // bounds[4] = 0;

                                // eslint-disable-next-line
                                loader.textWidth = bounds[0];
                                // eslint-disable-next-line
                                loader.textHeight = bounds[1];
                                // eslint-disable-next-line
                                loader.textSpacing = bounds[2];
                                // eslint-disable-next-line
                                loader.textDescent = bounds[4];

                                self.placement.placement.custom['personalization-descent'] = bounds[4].toString();
                                self.placement.placement.custom['personalization-ascent'] = bounds[3].toString();
                                self.placement.placement.custom['personalization-spacing'] = bounds[2].toString();

                                let lockWidth = false;
                                if (self.controller.blueprint.custom['no-box-sizing'] === 'true') {
                                    lockWidth = true;
                                }

                                if (self.placement.placement.code.startsWith(constants.PLACEMENT_MONOGRAM)) {
                                    lockWidth = true;
                                }

                                let placementWidth = +(component.custom['personalization-width'] || '0');
                                if (placementWidth < bounds[0] || lockWidth) {
                                    const dWidth = bounds[0] - placementWidth;

                                    // eslint-disable-next-line prefer-destructuring
                                    placementWidth = bounds[0];
                                    self.placement.placement.components.forEach((c) => {
                                        c.custom['personalization-width'] = placementWidth.toString();
                                    });

                                    // Adjust placement position.
                                    const align = self.placement.placement.components[0].custom['personalization-alignment'];

                                    if (align === 'left') {
                                        // Nothing to adjust.
                                    }

                                    if (align === 'center') {
                                        let x = +((component.custom && component.custom['personalization-x']) || '0');
                                        x -= dWidth * 0.5;

                                        self.placement.placement.components.forEach((c) => {
                                            c.custom['personalization-x'] = x.toString();
                                        });
                                    }

                                    if (align === 'right') {
                                        let x = +((component.custom && component.custom['personalization-x']) || '0');
                                        x -= dWidth;

                                        self.placement.placement.components.forEach((c) => {
                                            c.custom['personalization-x'] = x.toString();
                                        });
                                    }
                                }

                                // Save minimum width.
                                self.placement.placement.components.forEach((c) => {
                                    c.custom['personalization-min-width'] = bounds[0].toString();
                                });

                                let placementHeight = +(component.custom['personalization-height'] || '0');

                                if (placementHeight < bounds[1] || isMonogram) {
                                    const dHeight = bounds[1] - placementHeight;

                                    // eslint-disable-next-line prefer-destructuring
                                    placementHeight = bounds[1];
                                    self.placement.placement.components.forEach((c) => {
                                        c.custom['personalization-height'] = placementHeight.toString();
                                    });

                                    // Adjust placement position.
                                    const align = self.placement.placement.components[0].custom['personalization-vertical-alignment'];

                                    if (align === 'top') {
                                        // Nothing to adjust.
                                    }

                                    if (align === 'center') {
                                        let y = +((component.custom && component.custom['personalization-y']) || '0');
                                        y -= dHeight * 0.5;

                                        self.placement.placement.components.forEach((c) => {
                                            c.custom['personalization-y'] = y.toString();
                                        });
                                    }

                                    if (align === 'right') {
                                        let y = +((component.custom && component.custom['personalization-y']) || '0');
                                        y -= dHeight;

                                        self.placement.placement.components.forEach((c) => {
                                            c.custom['personalization-y'] = y.toString();
                                        });
                                    }
                                }

                                let lastRenderedX = +((component.custom && component.custom['personalization-x']) || '0');
                                let lastRenderedY = +((component.custom && component.custom['personalization-y']) || '0');

                                lastRenderedX += (+((component.custom && component.custom['personalization-width']) || '0')) * 0.5;
                                lastRenderedY += (+((component.custom && component.custom['personalization-height']) || '0')) * 0.5;

                                self.placement.placement.custom['last-personalization-x'] = lastRenderedX.toString();
                                self.placement.placement.custom['last-personalization-y'] = lastRenderedY.toString();

                                // Adjust bounding box.
                                if (self.placement.placement.custom['personalization-bbox-top']) {
                                    const dHeightBbox = bounds[1] - (+self.placement.placement.custom['personalization-bbox-base-height']);
                                    // eslint-disable-next-line max-len
                                    self.placement.placement.custom['personalization-bbox-top'] = (+(self.placement.placement.custom['personalization-bbox-top']) + (dHeightBbox * 0.5)).toString();
                                }

                                if (self.placement.placement.custom['personalization-bbox-left']) {
                                    const dWidthBbox = bounds[0] - (+self.placement.placement.custom['personalization-bbox-base-width']);
                                    // eslint-disable-next-line max-len
                                    self.placement.placement.custom['personalization-bbox-left'] = (+(self.placement.placement.custom['personalization-bbox-left']) + (dWidthBbox * 0.5)).toString();
                                }
                            }
                        } catch (e) {
                            // Nothing.
                        }
                    }

                    webp(this.response).then((decodedUrl) => {
                        if (decodedUrl) {
                            loader.image.onload = function onImageLoad() {
                                loader.ready = true;

                                self.paint();
                            };

                            loader.image.src = decodedUrl;
                        } else {
                            const blobUrl = URL.createObjectURL(this.response);

                            loader.image.onload = function onImageLoad() {
                                loader.ready = true;
                                URL.revokeObjectURL(blobUrl);

                                self.paint();
                            };

                            loader.image.src = blobUrl;
                        }
                    });
                };

                loader.xhr.onerror = function onXhrError() {
                    if (loader.cancelled) {
                        return;
                    }

                    if (!loader.error) {
                        loader.ready = true;
                        loader.error = true;

                        self.paint();
                    }
                };

                loader.xhr.onreadystatechange = function onReadyState(e) {
                    if (loader.cancelled) {
                        return;
                    }

                    if (e && e.target) {
                        if (e.target.status > 200) {
                            loader.ready = true;
                            loader.error = true;

                            self.paint();
                        }
                    }
                };

                window.requestAnimationFrame(() => {
                    loader.xhr.open('GET', loader.url, true);
                    loader.xhr.responseType = 'blob';
                    loader.xhr.send();
                });

                return loader;
            },

            /**
             * Calculates the projection from the screen space to the texture space using cylinder mapping.
             */
            unmapCylinderAngle(x, r, start, end, offset) {
                let n = -x / r;

                if (n < -1) {
                    n = -1;
                } else if (n > 1) {
                    n = 1;
                }

                const a = (Math.acos(n) * 180) / Math.PI;

                const mapped = a + offset;

                const l = (r * mapped * Math.PI) / 180;

                return l;
            },

            /**
             * Calculates the projection from the texture space to the screen space using cylinder mapping.
             */
            mapCylinderAngle(l, r, start, end, offset) {
                const mapped = (l * 180) / (r * Math.PI);

                const a = mapped - offset;

                const n = Math.cos((a * Math.PI) / 180);

                const x = -n * r;

                return x;
            },

            /**
             * Paint the image in the editor.
             * @return {void}
             */
            paintDebounced() {
                this.paintTimer = null;

                // Bail if prerequisites are not loaded yet.
                if (!this.placement) {
                    return;
                }

                let haveImage = this.image != null;

                let imageLoading = false;

                if (this.image && !this.image.ready) {
                    haveImage = false;
                    imageLoading = true;
                }

                if (this.mask && !this.mask.ready) {
                    haveImage = false;
                    imageLoading = true;
                }

                if (this.viewMask && !this.viewMask.ready) {
                    haveImage = false;
                    imageLoading = true;
                }

                if (this.overlay && !this.overlay.ready) {
                    haveImage = false;
                    imageLoading = true;
                }

                if (this.image && this.image.error) {
                    haveImage = false;
                }

                if (this.mask && this.mask.error) {
                    haveImage = false;
                }

                if (this.viewMask && this.viewMask.error) {
                    haveImage = false;
                }

                if (this.overlay && this.overlay.error) {
                    haveImage = false;
                }

                if (imageLoading) {
                    return;
                }

                // We could use either live image dimensions or ones stored as dynamic-image-width/height.
                const designOn = this.view.custom['v-design-area'];

                const {
                    left, top, right, bottom,
                } = designArea(this.$store.state.customizer, designOn);

                if (designOn == null || designOn.length === 0) {
                    // This one is really required.
                    if (this.$refs.sizeborder) {
                        this.$refs.sizeborder.style.display = 'none';
                    }
                    return;
                }

                const iw = this.controller.blueprint.custom['v-printing-width'];
                const ih = this.controller.blueprint.custom['v-printing-height'];

                if (iw == null || ih == null) {
                    // Also required.
                    if (this.$refs.sizeborder) {
                        this.$refs.sizeborder.style.display = 'none';
                    }
                    return;
                }

                const { container } = this.$refs;
                if (container == null) {
                    return;
                }

                let surface = container.querySelector('canvas');

                if (surface == null) {
                    const { code } = this.placement.placement;

                    const component = this.controller.selectedAtPlacement(code);

                    if (this.index === 0 || this.enabled || isFilled(component)) {
                        surface = document.createElement('canvas');

                        container.insertBefore(surface, container.firstChild);

                        this.resizeCanvas(container, surface);
                    } else {
                        return;
                    }
                }

                // Clear canvas before rendering new content.
                const w = surface.width;
                const h = surface.height;

                const ctx = surface.getContext('2d');
                ctx.clearRect(0, 0, w, h);

                const { component } = this.placement;

                // Figure out base image scaling factor to fit into the allowed space.
                const {
                    dpiScaleFactor,
                    baseWidth,
                    baseHeight,
                    baseScale,
                    dw,
                    dh,
                } = this.baseScale();

                // Check for view specific rendering.
                let rendered = false;

                // Extact dynamic image placement.
                let x;
                let y;
                let offsetX;
                let offsetY;
                let scale;
                let rotate;
                let componentWidth = 0;
                let componentHeight = 0;

                if (component.custom['widget-type'] === 'personalization') {
                    x = +((component.custom && component.custom['personalization-x']) || '0');
                    y = +((component.custom && component.custom['personalization-y']) || '0');

                    offsetX = (+((component.custom && component.custom['personalization-width']) || '0')) * 0.5;
                    offsetY = (+((component.custom && component.custom['personalization-height']) || '0')) * 0.5;

                    componentWidth = (+((component.custom && component.custom['personalization-width']) || '0'));
                    componentHeight = (+((component.custom && component.custom['personalization-height']) || '0'));

                    scale = +((component.custom && component.custom['personalization-scale']) || '1');
                    rotate = +((component.custom && component.custom['personalization-rotate']) || '0');

                    x += offsetX;
                    y += offsetY;
                } else {
                    x = +((component.custom && component.custom['dynamic-image-x']) || '0');
                    y = +((component.custom && component.custom['dynamic-image-y']) || '0');

                    offsetX = +((component.custom && component.custom['dynamic-image-offset-x']) || '0');
                    offsetY = +((component.custom && component.custom['dynamic-image-offset-y']) || '0');

                    if (haveImage) {
                        // eslint-disable-next-line
                        componentWidth = (+((component.custom && component.custom['dynamic-image-width']) || '0'));
                        componentHeight = (+((component.custom && component.custom['dynamic-image-height']) || '0'));
                    }

                    x += offsetX;
                    y += offsetY;

                    scale = +((component.custom && component.custom['dynamic-image-scale']) || '1');
                    rotate = +((component.custom && component.custom['dynamic-image-rotate']) || '0');
                }

                if (this.progressScale != null) {
                    scale = this.progressScale;
                }

                if (this.progressRotate != null) {
                    rotate = this.progressRotate;
                }

                // Dimenions according to the current scale fit factor.
                const diw = iw * scale;
                const dih = ih * scale;

                // Dimensions on the canvas (which is scaled), according to the DPI scale factor and fitting method of images onto canvas.
                const targetWidth = diw * dpiScaleFactor * baseScale;
                const targetHeight = dih * dpiScaleFactor * baseScale;

                // View based scale.
                let visualScale = 1;

                if (this.view && this.view.placements) {
                    const { code } = this.placement.placement;

                    const viewSettings = this.view.placements.find((p) => p.code === code);

                    if (viewSettings && viewSettings.custom && viewSettings.custom.group) {
                        // Is there a placement that uses that group as a source.
                        const sourceName = `g!${viewSettings.custom.group}`;
                        const useGroup = this.view.placements.find((p) => p.custom && p.custom.source === sourceName);

                        if (useGroup && useGroup.custom && useGroup.custom.projection) {
                            rendered = true;

                            ctx.resetTransform();

                            const canvasX = (w - (baseWidth * baseScale * dpiScaleFactor)) * 0.5;
                            const canvasY = (h - (baseHeight * baseScale * dpiScaleFactor)) * 0.5;

                            ctx.translate(canvasX, canvasY);
                            ctx.scale(baseScale * dpiScaleFactor, baseScale * dpiScaleFactor);

                            let { transform } = useGroup.custom;

                            if (useGroup.custom['transform-editor']) {
                                transform = useGroup.custom['transform-editor'];
                            }

                            if (transform) {
                                const transformParts = transform.match(/[a-z0-9]+\([^)]+\)/g);
                                if (transformParts.length > 0) {
                                    transformParts.forEach((t) => {
                                        const op = /([a-z0-9]+)\((.+)\)/g.exec(t);

                                        if (op.length === 3) {
                                            const name = op[1];
                                            const params = op[2].split(',').map((v) => +v.trim());

                                            if (name === 'pos3d') {
                                                ctx.translate(params[0], params[1]);
                                            }

                                            if (name === 'scale3d') {
                                                if (params.length === 1) {
                                                    // eslint-disable-next-line
                                                    visualScale = params[0];
                                                    ctx.scale(params[0], params[0]);
                                                } else {
                                                    // eslint-disable-next-line
                                                    visualScale = params[0];
                                                    ctx.scale(params[0], params[1]);
                                                }
                                            }
                                        }
                                    });
                                }
                            }

                            // Apply temporary adjustments.
                            if (this.progressX != null) {
                                x += (this.progressX / baseScale) * visualScale;
                            }

                            if (this.progressY != null) {
                                y += (this.progressY / baseScale) * visualScale;
                            }

                            const projectionY = -(bottom - top) * 0.5;

                            const arcOffset = +(useGroup.custom['projection-arc-offset'] || '0');
                            const arcStart = +(useGroup.custom['projection-arc-start'] || '0');
                            const arcEnd = +(useGroup.custom['projection-arc-end'] || '0');

                            const slices = 32;

                            // Calculate the arc length to know how wide the image would end up.
                            const r = +(useGroup.custom['projection-radius']);

                            const arc = (((arcEnd - arcStart) * 0.5) / 180) * Math.PI;

                            const renderWidth = r * Math.sin(arc) * 2;

                            const xStep = renderWidth / slices;
                            let projectionX = -renderWidth * 0.5;

                            let imageX = this.unmapCylinderAngle(projectionX, r, arcStart, arcEnd, arcOffset);

                            // Preshift the image when dragging.
                            const m = ctx.getTransform();

                            if (haveImage && !this.bordersOnly) {
                                const minImageX = imageX;
                                const buffer = [];

                                for (let slice = 0; slice < slices; slice += 1) {
                                    const nextX = projectionX + xStep;
                                    const nextImageX = this.unmapCylinderAngle(nextX, r, arcStart, arcEnd, arcOffset);

                                    buffer.push([
                                        // eslint-disable-next-line no-bitwise
                                        (imageX) | 0, 0, (nextImageX | 0) - (imageX | 0), ih,
                                        // eslint-disable-next-line no-bitwise
                                        (projectionX | 0) - 0.5, projectionY, ((nextX | 0) - (projectionX | 0)) + 1.0, ih,
                                    ]);

                                    projectionX = nextX;
                                    imageX = nextImageX;
                                }

                                const maxImageX = imageX;

                                const imageEndX = minImageX + (maxImageX - minImageX) + (maxImageX - minImageX);

                                // Rotate the image first.
                                // eslint-disable-next-line
                                let sourceImage = this.image.image;

                                const { imageBuffer, imageBufferWidth, imageBufferHeight } = renderHelper.getRenderBuffer(iw, ih);

                                if (imageBuffer) {
                                    const bufferCtx = imageBuffer.getContext('2d');

                                    bufferCtx.clearRect(0, 0, imageBufferWidth, imageBufferHeight);

                                    let lastRenderedX = 0;
                                    let lastRenderedY = 0;

                                    let pX = this.progressX;
                                    let pY = this.progressY;

                                    if (component.custom['widget-type'] === 'personalization') {
                                        lastRenderedX = +((this.placement.placement.custom['last-personalization-x']) || '0');
                                        lastRenderedY = +((this.placement.placement.custom['last-personalization-y']) || '0');

                                        // Adjust progress position in case the center point had changed due to alignment.
                                        let cpX = +((component.custom && component.custom['personalization-x']) || '0');
                                        let cpY = +((component.custom && component.custom['personalization-y']) || '0');
                                        cpX += +((component.custom && component.custom['personalization-width']) || '0') * 0.5;
                                        cpY += +((component.custom && component.custom['personalization-height']) || '0') * 0.5;

                                        const align = component.custom['personalization-alignment'];

                                        if (align === 'center') {
                                            pX += (cpX - lastRenderedX) * 0.5;
                                            pY += (cpY - lastRenderedY) * 0.5;
                                        }

                                        if (align === 'left') {
                                            if (this.progressRightSide) {
                                                pX += 0;
                                            } else {
                                                pX += (cpX - lastRenderedX);
                                            }
                                            pY += (cpY - lastRenderedY) * 0.5;
                                        }

                                        if (align === 'right') {
                                            if (this.progressRightSide) {
                                                pX += 0;
                                            } else {
                                                pX -= (cpX - lastRenderedX);
                                            }
                                            pX -= (cpX - lastRenderedX) * 0.5;
                                            pY += (cpY - lastRenderedY) * 0.5;
                                        }
                                    } else {
                                        lastRenderedX = +((component.custom && component.custom['dynamic-image-x']) || '0');
                                        lastRenderedY = +((component.custom && component.custom['dynamic-image-y']) || '0');

                                        lastRenderedX += +((component.custom && component.custom['dynamic-image-offset-x']) || '0');
                                        lastRenderedY += +((component.custom && component.custom['dynamic-image-offset-y']) || '0');
                                    }

                                    bufferCtx.resetTransform();

                                    bufferCtx.translate(lastRenderedX, lastRenderedY);

                                    if (this.progressRotate != null) {
                                        bufferCtx.rotate((-this.progressRotateStart + this.progressRotate) * (Math.PI / 180));
                                    }

                                    if (this.progressScale != null) {
                                        const f = this.progressScale / this.progressScaleStart;

                                        bufferCtx.scale(f, f);
                                    }

                                    bufferCtx.translate(-lastRenderedX, -lastRenderedY);

                                    const deltaX = (pX / baseScale) * visualScale;
                                    const deltaY = (pY / baseScale) * visualScale;

                                    bufferCtx.translate(deltaX, deltaY);

                                    if (this.layerScale !== 1) {
                                        bufferCtx.scale(1 / this.layerScale, 1 / this.layerScale);
                                    }

                                    bufferCtx.drawImage(this.image.image, 0, 0);

                                    if (this.mask) {
                                        bufferCtx.resetTransform();

                                        bufferCtx.globalCompositeOperation = 'destination-in';

                                        if (this.layerScale !== 1) {
                                            bufferCtx.scale(1 / this.layerScale, 1 / this.layerScale);
                                        }

                                        // Mask is supposed to be of the same dimensions as the base image.
                                        // eslint-disable-next-line
                                        bufferCtx.drawImage(this.mask.image, 0, 0);

                                        bufferCtx.globalCompositeOperation = 'source-over';
                                    }

                                    sourceImage = imageBuffer;
                                }

                                const backOpacity = +(useGroup.custom['projection-backface-opacity'] || '0');

                                buffer.forEach((s) => {
                                    const offset = s[0] - minImageX;

                                    ctx.save();
                                    ctx.translate(s[4], s[5]);
                                    ctx.scale(-1, 1);
                                    ctx.globalAlpha = backOpacity;
                                    ctx.drawImage(sourceImage, imageEndX - offset - s[2], s[1], s[2], s[3], 0, 0, s[6], s[7]);
                                    ctx.restore();
                                });

                                buffer.reverse();

                                buffer.forEach((s) => {
                                    ctx.drawImage(sourceImage, s[0], s[1], s[2], s[3], s[4], s[5], s[6], s[7]);
                                });
                            }

                            // Figure out widget placement.

                            let areaX = null;
                            let areaY = null;

                            if (component.custom['dynamic-image-area-x']) {
                                areaX = +component.custom['dynamic-image-area-x'];
                            }

                            if (areaX == null && component.custom['dynamic-image-area-center-x']) {
                                areaX = +component.custom['dynamic-image-area-center-x'] - (+component.custom['dynamic-image-area-width'] * 0.5);
                            }

                            if (areaX == null) {
                                areaX = 0;
                            }

                            if (component.custom['dynamic-image-area-y']) {
                                areaY = +component.custom['dynamic-image-area-y'];
                            }

                            if (areaY == null && component.custom['dynamic-image-area-center-y']) {
                                areaY = +component.custom['dynamic-image-area-center-y'] - (+component.custom['dynamic-image-area-height'] * 0.5);
                            }

                            if (areaY == null) {
                                areaY = 0;
                            }

                            if (haveImage && !this.bordersOnly) {
                                const isMonogram = this.placement.placement.code.startsWith(constants.PLACEMENT_MONOGRAM);

                                // eslint-disable-next-line
                                const bbox = extent(
                                    this.placement.placement,
                                    component,
                                    ((this.progressX || 0) / baseScale) * visualScale,
                                    ((this.progressY || 0) / baseScale) * visualScale,
                                    scale,
                                    rotate,
                                    {
                                        adjustMonogram: true,
                                    },
                                );

                                // eslint-disable-next-line
                                const bboxOriginal = extent(
                                    this.placement.placement,
                                    component,
                                    ((this.progressX || 0) / baseScale) * visualScale,
                                    ((this.progressY || 0) / baseScale) * visualScale,
                                    scale,
                                    rotate,
                                    {
                                        adjustMonogram: false,
                                    },
                                );

                                let outsideLeft = false;
                                let outsideRight = false;
                                let outsideTop = false;
                                let outsideBottom = false;

                                let boxX = bbox.x;
                                let boxY = bbox.y;
                                let boxDx = bbox.dx;
                                let boxDy = bbox.dy;
                                let boxDyBottom = bbox.dyBottom;

                                if (isMonogram) {
                                    if (this.placement.placement.custom['personalization-bbox-width']) {
                                        if (this.progressScale != null && this.progressScaleStart != null) {
                                            const rw = +(this.placement.placement.custom['personalization-bbox-width']);
                                            const rh = +(this.placement.placement.custom['personalization-bbox-height']);
                                            const rl = +(this.placement.placement.custom['personalization-bbox-left']);
                                            const rt = +(this.placement.placement.custom['personalization-bbox-top']);

                                            const f = this.progressScale / this.progressScaleStart;

                                            boxX -= rw * 0.5;
                                            boxY -= rh * 0.5;

                                            boxX -= rl;
                                            boxY -= rt;

                                            boxX += rl * f;
                                            boxY += rt * f;

                                            const rwProgress = rw * f;
                                            const rhProgress = rh * f;

                                            boxX += rwProgress * 0.5;
                                            boxY += rhProgress * 0.5;

                                            boxDx *= f;
                                            boxDy *= f;
                                            boxDyBottom *= f;
                                        }
                                    }
                                }

                                // Check for boundaries overlap.
                                if (this.enabled && left != null && top != null && right != null && bottom != null) {
                                    if (isFilled(component) && component.custom['v-design-on'] === designOn) {
                                        let outside = false;

                                        if (this.controller.blueprint.custom['v-design-wrap'] !== 'true') {
                                            if (boxX - boxDx < left - 0.001) {
                                                outside = true;
                                                outsideLeft = true;
                                            }

                                            if (boxX - boxDx > right + 0.001) {
                                                outsideLeft = true;
                                            }

                                            if (boxX + boxDx > right + 0.001) {
                                                outside = true;
                                                outsideRight = true;
                                            }

                                            if (boxX + boxDx < left - 0.001) {
                                                outsideRight = true;
                                            }
                                        }

                                        if (boxY - boxDy < top - 0.001) {
                                            outside = true;
                                            outsideTop = true;
                                        }

                                        if (boxY - boxDy > bottom + 0.001) {
                                            outsideTop = true;
                                        }

                                        if (boxY + boxDyBottom > bottom + 0.001) {
                                            outside = true;
                                            outsideBottom = true;
                                        }

                                        if (boxY + boxDyBottom < top - 0.001) {
                                            outsideBottom = true;
                                        }

                                        this.$store.dispatch('setDesignOutside', outside);
                                    }
                                }

                                // Figure out how to place the sizing guide.
                                if (this.enabled) {
                                    let guideX;
                                    let guideYTop;
                                    let guideYBottom;

                                    let guideXOriginal;
                                    let guideYTopOriginal;
                                    let guideYBottomOriginal;

                                    const boxXOriginal = bboxOriginal.x;
                                    const boxYOriginal = bboxOriginal.y;

                                    if (component.custom['widget-type'] === 'personalization') {
                                        guideX = componentWidth * 0.5;
                                        guideYTop = componentHeight * 0.5;
                                        guideYBottom = (componentHeight * 0.5) + (bbox.descent);

                                        guideXOriginal = guideX;
                                        guideYTopOriginal = guideYTop;
                                        guideYBottomOriginal = guideYBottom;

                                        if (isMonogram) {
                                            if (this.placement.placement.custom['personalization-bbox-width']) {
                                                let rw = +(this.placement.placement.custom['personalization-bbox-width']);
                                                let rh = +(this.placement.placement.custom['personalization-bbox-height']);

                                                let f = 1;

                                                if (this.progressScale != null && this.progressScaleStart != null) {
                                                    f = this.progressScale / this.progressScaleStart;

                                                    const rwProgress = rw * f;
                                                    const rhProgress = rh * f;

                                                    rw = rwProgress;
                                                    rh = rhProgress;
                                                }

                                                guideX = rw * 0.5;
                                                guideYTop = rh * 0.5;
                                                guideYBottom = rh * 0.5;
                                            }
                                        }
                                    } else {
                                        guideX = componentWidth * scale * 0.5;
                                        guideYTop = componentHeight * scale * 0.5;
                                        guideYBottom = componentHeight * scale * 0.5;

                                        guideXOriginal = guideX;
                                        guideYTopOriginal = guideYTop;
                                        guideYBottomOriginal = guideYBottom;
                                    }

                                    const guidePoints = [
                                        [areaX + boxX, areaY + boxY + projectionY, 0, 0],
                                        [areaX + boxX + guideX, areaY + boxY + projectionY + guideYBottom, 0, 0, 0, 0, 'rb'],
                                        [areaX + boxX + guideX, areaY + boxY + projectionY - guideYTop, 0, 0, 0, 0, 'rt'],
                                        [areaX + boxX - guideX, areaY + boxY + projectionY - guideYTop, 0, 0, 0, 0, 'lt'],
                                        [areaX + boxX - guideX, areaY + boxY + projectionY + guideYBottom, 0, 0, 0, 0, 'lb'],
                                    ];

                                    const guidePointsOriginal = [
                                        [areaX + boxXOriginal, areaY + boxYOriginal + projectionY, 0, 0],
                                        [areaX + boxXOriginal + guideXOriginal, areaY + boxYOriginal + projectionY + guideYBottomOriginal, 0, 0, 0, 0, 'rb'],
                                        [areaX + boxXOriginal + guideXOriginal, areaY + boxYOriginal + projectionY - guideYTopOriginal, 0, 0, 0, 0, 'rt'],
                                        [areaX + boxXOriginal - guideXOriginal, areaY + boxYOriginal + projectionY - guideYTopOriginal, 0, 0, 0, 0, 'lt'],
                                        [areaX + boxXOriginal - guideXOriginal, areaY + boxYOriginal + projectionY + guideYBottomOriginal, 0, 0, 0, 0, 'lb'],
                                    ];

                                    const rotateCos = Math.cos((rotate * Math.PI) / 180);
                                    const rotateSin = Math.sin((rotate * Math.PI) / 180);
                                    const rotateCosBack = Math.cos((-rotate * Math.PI) / 180);
                                    const rotateSinBack = Math.sin((-rotate * Math.PI) / 180);

                                    // The box is based on untransformed text dimensions (i.e. if the text is rotated 90, the box is still <----->)
                                    // Rotate the box back so it is in the proper position.
                                    // Fix the width because of the cylindrical projection.
                                    // Rotate it back to the untransformed state.
                                    //  Use CSS transform to rotate the box again when displaying it.

                                    const transformPoints = (gp) => {
                                        gp.forEach((pt) => {
                                            const ptX = pt[0] - gp[0][0];
                                            const ptY = pt[1] - gp[0][1];

                                            const dx = rotateCos * ptX - rotateSin * ptY;
                                            const dy = rotateSin * ptX + rotateCos * ptY;

                                            pt[0] = dx + gp[0][0];
                                            pt[1] = dy + gp[0][1];
                                        });

                                        gp.forEach((pt) => {
                                            const dotScreenX = this.mapCylinderAngle(pt[0], r, arcStart, arcEnd, arcOffset);
                                            const dotScreenY = pt[1];

                                            pt[2] = ((m.a * dotScreenX) + (m.c * dotScreenY) + m.e) - (w * 0.5);
                                            pt[3] = ((m.b * dotScreenX) + (m.d * dotScreenY) + m.f) - (h * 0.5);
                                        });

                                        gp.forEach((pt) => {
                                            const ptX = pt[2] - gp[0][2];
                                            const ptY = pt[3] - gp[0][3];

                                            const dx = rotateCosBack * ptX - rotateSinBack * ptY;
                                            const dy = rotateSinBack * ptX + rotateCosBack * ptY;

                                            pt[4] = dx + gp[0][2];
                                            pt[5] = dy + gp[0][3];
                                        });
                                    };

                                    transformPoints(guidePoints);

                                    transformPoints(guidePointsOriginal);

                                    this.$refs['sizeguidehandle-lt'].classList.remove('cz2__client-image-sizeonlyhandle--outside');
                                    this.$refs['sizeguidehandle-lb'].classList.remove('cz2__client-image-sizeonlyhandle--outside');
                                    this.$refs['sizeguidehandle-rt'].classList.remove('cz2__client-image-sizeonlyhandle--outside');
                                    this.$refs['sizeguidehandle-rb'].classList.remove('cz2__client-image-sizeonlyhandle--outside');

                                    if (outsideTop) {
                                        let foundValue = guidePoints[1][1];

                                        for (let i = 2; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][1] < foundValue) {
                                                // eslint-disable-next-line prefer-destructuring
                                                foundValue = guidePoints[i][1];
                                            }
                                        }

                                        for (let i = 1; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][1] === foundValue) {
                                                this.$refs[`sizeguidehandle-${guidePoints[i][6]}`].classList.add('cz2__client-image-sizeonlyhandle--outside');
                                            }
                                        }
                                    }

                                    if (outsideBottom) {
                                        let foundValue = guidePoints[1][1];

                                        for (let i = 2; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][1] > foundValue) {
                                                // eslint-disable-next-line prefer-destructuring
                                                foundValue = guidePoints[i][1];
                                            }
                                        }

                                        for (let i = 1; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][1] === foundValue) {
                                                this.$refs[`sizeguidehandle-${guidePoints[i][6]}`].classList.add('cz2__client-image-sizeonlyhandle--outside');
                                            }
                                        }
                                    }

                                    if (outsideLeft) {
                                        let foundValue = guidePoints[1][0];

                                        for (let i = 2; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][0] < foundValue) {
                                                // eslint-disable-next-line prefer-destructuring
                                                foundValue = guidePoints[i][0];
                                            }
                                        }

                                        for (let i = 1; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][0] === foundValue) {
                                                this.$refs[`sizeguidehandle-${guidePoints[i][6]}`].classList.add('cz2__client-image-sizeonlyhandle--outside');
                                            }
                                        }
                                    }

                                    if (outsideRight) {
                                        let foundValue = guidePoints[1][0];

                                        for (let i = 2; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][0] > foundValue) {
                                                // eslint-disable-next-line prefer-destructuring
                                                foundValue = guidePoints[i][0];
                                            }
                                        }

                                        for (let i = 1; i < guidePoints.length; i += 1) {
                                            if (guidePoints[i][0] === foundValue) {
                                                this.$refs[`sizeguidehandle-${guidePoints[i][6]}`].classList.add('cz2__client-image-sizeonlyhandle--outside');
                                            }
                                        }
                                    }

                                    const guideMinX = Math.min(guidePoints[0][4], guidePoints[1][4], guidePoints[2][4], guidePoints[3][4], guidePoints[4][4]);
                                    const guideMaxX = Math.max(guidePoints[0][4], guidePoints[1][4], guidePoints[2][4], guidePoints[3][4], guidePoints[4][4]);

                                    const guideMinY = Math.min(guidePoints[0][5], guidePoints[1][5], guidePoints[2][5], guidePoints[3][5], guidePoints[4][5]);
                                    const guideMaxY = Math.max(guidePoints[0][5], guidePoints[1][5], guidePoints[2][5], guidePoints[3][5], guidePoints[4][5]);

                                    const guideCenterX = (guideMinX + guideMaxX) * 0.5;
                                    // eslint-disable-next-line
                                    let guideCenterY = (guideMinY + guideMaxY) * 0.5;

                                    // eslint-disable-next-line
                                    const rotateFactor = Math.abs(rotateCos);
                                    // There is no logical explanation for this, just trying it out.
                                    guideCenterY = guideCenterY * rotateFactor + guidePoints[0][5] * (1 - rotateFactor);

                                    const guideWidth = (guideMaxX - guideMinX);
                                    const guideHeight = (guideMaxY - guideMinY);

                                    const guideMinXOriginal = Math.min(
                                        guidePointsOriginal[0][4],
                                        guidePointsOriginal[1][4],
                                        guidePointsOriginal[2][4],
                                        guidePointsOriginal[3][4],
                                        guidePointsOriginal[4][4],
                                    );
                                    const guideMaxXOriginal = Math.max(
                                        guidePointsOriginal[0][4],
                                        guidePointsOriginal[1][4],
                                        guidePointsOriginal[2][4],
                                        guidePointsOriginal[3][4],
                                        guidePointsOriginal[4][4],
                                    );
                                    const guideMinYOriginal = Math.min(
                                        guidePointsOriginal[0][5],
                                        guidePointsOriginal[1][5],
                                        guidePointsOriginal[2][5],
                                        guidePointsOriginal[3][5],
                                        guidePointsOriginal[4][5],
                                    );
                                    const guideMaxYOriginal = Math.max(
                                        guidePointsOriginal[0][5],
                                        guidePointsOriginal[1][5],
                                        guidePointsOriginal[2][5],
                                        guidePointsOriginal[3][5],
                                        guidePointsOriginal[4][5],
                                    );

                                    const guideCenterXOriginal = (guideMinXOriginal + guideMaxXOriginal) * 0.5;
                                    const guideCenterYOriginal = (guideMinYOriginal + guideMaxYOriginal) * 0.5;

                                    // Place guides, which are real DOM content and are using CSS instead of being painted on the canvas.
                                    if (this.$refs.sizeguide) {
                                        // eslint-disable-next-line
                                        this.$refs.sizeguide.style.transform = `translate(calc(-50% + ${guideCenterX / dpiScaleFactor}px), calc(-50% + ${guideCenterY / dpiScaleFactor}px)) rotate(${rotate}deg)`;

                                        if (isMonogram) {
                                            // + 2px for the border.
                                            const aXOffset = -guideCenterX + guideCenterXOriginal + 2;
                                            const aYOffset = -guideCenterY + guideCenterYOriginal + 2;

                                            const aX = (guideWidth * 0.5) + aXOffset;
                                            const aY = (guideHeight * 0.5) + aYOffset;

                                            this.$refs.sizeguide.style.transformOrigin = `${aX / dpiScaleFactor}px ${aY / dpiScaleFactor}px`;
                                        }

                                        // +4 is for the 2px border offset.
                                        this.$refs.sizeguide.style.width = `${(guideWidth / dpiScaleFactor) + 4}px`;
                                        this.$refs.sizeguide.style.height = `${(guideHeight / dpiScaleFactor) + 4}px`;

                                        const guideOffsetX = 0;
                                        const guideOffsetY = 0;

                                        const guideOffsetDx = rotateCos * guideOffsetX - rotateSin * guideOffsetY;
                                        const guideOffsetDy = rotateSin * guideOffsetX + rotateCos * guideOffsetY;

                                        this.$refs.sizeguide.style.marginTop = `${Math.floor(guideOffsetDy)}px`;
                                        this.$refs.sizeguide.style.marginLeft = `${Math.floor(guideOffsetDx)}px`;

                                        // "Unrotate" the move guide so it would be screen aligned.
                                        this.$refs.moveguide.style.transform = `rotate(${(-rotate)}deg)`;
                                    }

                                    let hidden = false;

                                    if (component.custom['widget-type'] === 'personalization') {
                                        hidden = false;
                                    } else if (component.custom['dynamic-image-url'] == null || component.custom['dynamic-image-url'].length === 0) {
                                        hidden = true;
                                    }

                                    if (this.$refs.sizeguide) {
                                        this.$refs.sizeguide.style.display = !hidden ? 'block' : 'none';
                                    }
                                } else {
                                    this.$refs.sizeguide.style.display = 'none';
                                }
                            } else {
                                this.$refs.sizeguide.style.display = 'none';
                            }

                            if (this.index === 0 && this.showBorders && left != null && top != null && right != null && bottom != null) {
                                const leftArc = this.mapCylinderAngle(left, r, arcStart, arcEnd, arcOffset);
                                const rightArc = this.mapCylinderAngle(right, r, arcStart, arcEnd, arcOffset);
                                const topArc = top + projectionY;
                                const bottomArc = bottom + projectionY;

                                const leftScreen = ((m.a * leftArc) + (m.c * topArc) + m.e) - (w * 0.5);
                                const topScreen = ((m.b * leftArc) + (m.d * topArc) + m.f) - (h * 0.5);
                                const rightScreen = ((m.a * rightArc) + (m.c * bottomArc) + m.e) - (w * 0.5);
                                const bottomScreen = ((m.b * rightArc) + (m.d * bottomArc) + m.f) - (h * 0.5);

                                if (this.$refs.sizeborder) {
                                    if (!Number.isNaN(leftArc) && !Number.isNaN(rightArc)) {
                                        this.$refs.sizeborder.style.display = 'block';

                                        // eslint-disable-next-line
                                        this.$refs.sizeborder.style.transform = `translate(calc(${leftScreen / dpiScaleFactor}px), calc(${topScreen / dpiScaleFactor}px))`;

                                        this.$refs.sizeborder.style.width = `${(rightScreen - leftScreen) / dpiScaleFactor}px`;
                                        this.$refs.sizeborder.style.height = `${(bottomScreen - topScreen) / dpiScaleFactor}px`;
                                    } else {
                                        this.$refs.sizeborder.style.display = 'none';
                                    }
                                }
                            } else if (this.$refs.sizeborder) {
                                this.$refs.sizeborder.style.display = 'none';
                            }
                        }
                    }
                }

                if (!rendered) {
                    // Apply temporary adjustments.
                    if (this.progressX != null) {
                        x += (this.progressX / baseScale);
                    }

                    if (this.progressY != null) {
                        y += (this.progressY / baseScale);
                    }

                    const ix = (x * dpiScaleFactor * baseScale) - (targetWidth * 0.5);
                    const iy = (y * dpiScaleFactor * baseScale) - (targetHeight * 0.5);

                    // eslint-disable-next-line no-bitwise
                    const cx = (((w - dw) / 2) + ix) | 0;
                    // eslint-disable-next-line no-bitwise
                    const cy = (((h - dh) / 2) + iy) | 0;

                    // Draw image rotated around center.
                    ctx.translate(cx + (targetWidth / 2), cy + (targetHeight / 2));
                    ctx.rotate((rotate * Math.PI) / 180);

                    ctx.drawImage(this.image.image, 0, 0, iw, ih, -targetWidth / 2, -targetHeight / 2, targetWidth, targetHeight);

                    // Place guides, which are real DOM content and are using CSS instead of being painted on the canvas.
                    // eslint-disable-next-line
                    this.$refs.sizeguide.style.transform = 'translate(calc(-50% + ' + ((offsetX + (this.progressX || 0)) * baseScale)
                        + 'px), calc(-50% + ' + ((offsetY + (this.progressY || 0)) * baseScale)
                        + 'px)) rotate(' + rotate + 'deg)';

                    let hidden = false;

                    if (component.custom['widget-type'] === 'personalization') {
                        hidden = false;
                    } else if (component.custom['dynamic-image-url'] == null || component.custom['dynamic-image-url'].length === 0) {
                        hidden = true;
                    }

                    this.$refs.sizeguide.style.display = !hidden ? 'block' : 'none';
                }

                ctx.resetTransform();

                if (this.viewMask && this.viewMask.ready && !this.viewMask.error) {
                    ctx.globalCompositeOperation = 'destination-in';

                    // eslint-disable-next-line
                    ctx.drawImage(this.viewMask.image, 0, 0, this.viewMask.image.width, this.viewMask.image.height, ((w - dw) / 2) | 0, ((h - dh) / 2) | 0, dw, dh);

                    ctx.globalCompositeOperation = 'source-over';
                }

                if (this.overlay && this.overlay.ready && !this.overlay.error) {
                    ctx.globalCompositeOperation = 'source-in';

                    // Mask is supposed to be of the same dimensions as the base image.
                    // eslint-disable-next-line
                    ctx.drawImage(this.overlay.image, 0, 0, this.overlay.image.width, this.overlay.image.height, ((w - dw) / 2) | 0, ((h - dh) / 2) | 0, dw, dh);

                    ctx.globalCompositeOperation = 'source-over';
                }
            },

            /**
             * Calculates canvas backing scale for HI-DPI screens.
             * @return {Number} backing scale.
             */
            backingScale() {
                return 2;
            },

            /**
             * Calculates a scaling factor to fit the base image onto the canvas.
             * @return {Number}
             */
            baseScale() {
                // Base width and height are used to determine overall scaling factor to fit images into the allowed screen space.
                let baseWidth = null;

                if (this.view.custom && this.view.custom['editor-base-width']) {
                    baseWidth = +this.view.custom['editor-base-width'];
                }

                if (baseWidth == null && this.placement.placement.custom['editor-base-width']) {
                    baseWidth = +this.placement.placement.custom['editor-base-width'];
                }

                if (baseWidth == null) {
                    baseWidth = 1000;
                }

                let baseHeight = null;

                if (this.view.custom && this.view.custom['editor-base-height']) {
                    baseHeight = this.view.custom['editor-base-height'];
                }

                if (baseHeight == null && this.placement.placement.custom['editor-base-height']) {
                    baseHeight = +this.placement.placement.custom['editor-base-height'];
                }

                if (baseHeight == null) {
                    baseHeight = 1000;
                }

                const { container } = this.$refs;

                const surface = container.querySelector('canvas');

                const w = surface.width;
                const h = surface.height;

                baseWidth = +baseWidth;
                baseHeight = +baseHeight;

                const dpiScaleFactor = this.backingScale();

                let dw = baseWidth * dpiScaleFactor;
                let dh = baseHeight * dpiScaleFactor;

                let baseScale = 1;

                if (dw > w) {
                    const f = w / dw;

                    baseScale *= f;
                    dw *= f;
                    dh *= f;
                    dw = w;
                }

                if (dh > h) {
                    const f = h / dh;

                    baseScale *= f;
                    dw *= f;
                    dh *= f;
                }

                return {
                    dpiScaleFactor,
                    baseWidth,
                    baseHeight,
                    baseScale,
                    dw,
                    dh,
                };
            },

            /**
             * Calculate any placement specific scaling factors.
             */
            visualScale() {
                let visualScale = 1;

                const viewSettings = this.view.placements.find((p) => p.code === this.placement.placement.code);

                if (viewSettings && viewSettings.custom && viewSettings.custom.group) {
                    // Is there a placement that uses that group as a source.
                    const sourceName = `g!${viewSettings.custom.group}`;
                    const useGroup = this.view.placements.find((p) => p.custom && p.custom.source === sourceName);

                    if (useGroup && useGroup.custom && useGroup.custom.projection) {
                        const { transform } = useGroup.custom;

                        if (transform) {
                            const transformParts = transform.match(/[a-z0-9]+\([^)]+\)/g);
                            if (transformParts.length > 0) {
                                transformParts.forEach((t) => {
                                    const op = /([a-z0-9]+)\((.+)\)/g.exec(t);

                                    if (op.length === 3) {
                                        const name = op[1];
                                        const params = op[2].split(',').map((v) => +v.trim());

                                        if (name === 'scale3d') {
                                            if (params.length === 1) {
                                                // eslint-disable-next-line
                                                visualScale *= params[0];
                                            } else {
                                                // eslint-disable-next-line
                                                visualScale *= params[0];
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                }

                return visualScale;
            },

            /**
             * Removes InteractJS integration, typically before VueJS DOM updates.
             * @return {void}
             */
            removeInteract() {
                if (this.interact) {
                    if (this.$refs.movehandle) {
                        interact(this.$refs.movehandle).unset();
                    }

                    if (this.$refs.sizeguidehandle) {
                        interact(this.$refs.sizeguidehandle).unset();
                    }

                    if (this.$refs['sizeguidehandle-lt']) {
                        interact(this.$refs['sizeguidehandle-lt']).unset();
                    }

                    if (this.$refs['sizeguidehandle-lb']) {
                        interact(this.$refs['sizeguidehandle-lb']).unset();
                    }

                    if (this.$refs['sizeguidehandle-rt']) {
                        interact(this.$refs['sizeguidehandle-rt']).unset();
                    }

                    if (this.$refs['sizeguidehandle-rb']) {
                        interact(this.$refs['sizeguidehandle-rb']).unset();
                    }

                    if (this.$refs.rotatehandle) {
                        interact(this.$refs.rotatehandle).unset();
                    }

                    this.interact = false;
                }
            },

            setActive(f) {
                if (this.$refs.sizeguide) {
                    if (f) {
                        if (!this.$refs.sizeguide.classList.contains('cz2__client-image-sizeguide--active')) {
                            this.$refs.sizeguide.classList.add('cz2__client-image-sizeguide--active');
                        }
                    } else if (this.$refs.sizeguide.classList.contains('cz2__client-image-sizeguide--active')) {
                        this.$refs.sizeguide.classList.remove('cz2__client-image-sizeguide--active');
                    }
                }
            },

            /**
             * Enables user interaction with the editor.
             */
            enableInteract() {
                this.removeInteract();

                if (!this.enabled) {
                    return;
                }

                if (!this.placement) {
                    return;
                }

                const { component } = this.placement;

                // eslint-disable-next-line
                let mainInteractable = this.$refs.movehandle ? interact(this.$refs.movehandle) : null;

                // Allow to drag the image on the surface.
                if (component.custom['widget-type'] === 'personalization') {
                    this.moveable = true;
                    this.sizeable = true;
                    this.rotateable = true;
                } else {
                    this.moveable = component.custom
                        && (component.custom['dynamic-image-allow-move'] === 'yes' || component.custom['dynamic-image-allow-move'] === 'true');
                    this.sizeable = component.custom
                        && (component.custom['dynamic-image-allow-resize'] === 'yes' || component.custom['dynamic-image-allow-resize'] === 'true');
                    this.rotateable = component.custom
                        && (component.custom['dynamic-image-allow-rotate'] === 'yes' || component.custom['dynamic-image-allow-rotate'] === 'true');
                }

                if (this.moveable && mainInteractable) {
                    // eslint-disable-next-line no-unused-vars
                    mainInteractable = mainInteractable.draggable({
                        // ignoreFrom: '.cz2__client-image-interact-inner',

                        onstart: () => {
                            this.setActive(true);

                            if (this.placement) {
                                this.progressX = 0;
                                this.progressY = 0;
                            }
                        },

                        onend: () => {
                            this.setActive(false);

                            if (this.placement) {
                                if (this.progressX != null || this.progressY != null) {
                                    const { baseScale } = this.baseScale();
                                    const visualScale = this.visualScale();

                                    let dix = 0;
                                    let diy = 0;

                                    dix += ((this.progressX || 0) / baseScale) * visualScale;
                                    diy += ((this.progressY || 0) / baseScale) * visualScale;

                                    // Commit changes.
                                    if (component.custom['widget-type'] === 'personalization') {
                                        let textX = +((component.custom && component.custom['personalization-x']) || '0') + (dix);
                                        const textY = +((component.custom && component.custom['personalization-y']) || '0') + (diy);

                                        this.progressX = null;
                                        this.progressY = null;

                                        let textWidth = (+((component.custom && component.custom['personalization-width']) || '0'));

                                        const textScale = +((component.custom && component.custom['personalization-scale']) || '1');

                                        textWidth *= textScale;

                                        const iw = +(this.controller.blueprint.custom['v-printing-width']);

                                        if (textX > iw) {
                                            textX -= iw;
                                        }

                                        if (textX + textWidth < 0) {
                                            textX += iw;
                                        }

                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'personalization-x': textX,
                                            'personalization-y': textY,
                                        }, {
                                            propagate: true,
                                        });
                                    } else {
                                        let imageX = +((component.custom && component.custom['dynamic-image-offset-x']) || '0') + (dix);
                                        const imageY = +((component.custom && component.custom['dynamic-image-offset-y']) || '0') + (diy);

                                        this.progressX = null;
                                        this.progressY = null;

                                        const absX = +((component.custom && component.custom['dynamic-image-x']) || '0');

                                        let width = (+((component.custom && component.custom['dynamic-image-width']) || '0'));

                                        const scale = +((component.custom && component.custom['dynamic-image-scale']) || '1');

                                        width *= scale;

                                        const iw = +(this.controller.blueprint.custom['v-printing-width']);

                                        if (absX + imageX - (width * 0.5) > iw) {
                                            imageX -= iw;
                                        }

                                        if (absX + imageX + (width * 0.5) < 0) {
                                            imageX += iw;
                                        }

                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'dynamic-image-offset-x': imageX,
                                            'dynamic-image-offset-y': imageY,
                                        });
                                    }

                                    // However cares about this stuff moving around might be very far in the Vue hierarchy
                                    // so we will use the global notification bus instead.
                                    this.$store.dispatch('layoutMoved', {
                                        placement: this.placement.placement,
                                        component,
                                    });
                                }

                                this.cancelPaint();
                            }
                        },

                        onmove: (event) => {
                            if (this.placement) {
                                const dx = event.pageX - event.x0;
                                let dy = event.pageY - event.y0;

                                if (event.shiftKey) {
                                    dy = 0;
                                }

                                // Use current viewport scale for 1:1 movement.
                                // Dynamic scale is not used for positioning.
                                const dpiScaleFactor = this.backingScale();

                                const idx = (dx * dpiScaleFactor);
                                const idy = (dy * dpiScaleFactor);

                                this.progressX = idx;
                                this.progressY = idy;

                                this.paint();
                            }
                        },
                    });
                }

                const sizeGuide = this.$refs.sizeguidehandle ? interact(this.$refs.sizeguidehandle) : null;
                if ((this.sizeable || this.rotateable) && sizeGuide) {
                    this.configureSizeInteract(component, sizeGuide, this.$refs.sizeguidehandle, true, true);
                }

                const corners = [
                    'sizeguidehandle-lt',
                    'sizeguidehandle-lb',
                    'sizeguidehandle-rt',
                    'sizeguidehandle-rb',
                ];

                let lockWidth = false;

                if (this.controller.blueprint.custom['no-box-sizing'] === 'true') {
                    lockWidth = true;
                }

                if (this.placement.placement.code.startsWith(constants.PLACEMENT_MONOGRAM)) {
                    lockWidth = true;
                }

                if (!lockWidth) {
                    corners.push('widthhandle-l');
                    corners.push('widthhandle-r');

                    if (this.$refs['widthhandle-r']) {
                        this.$refs['widthhandle-r'].style.display = 'block';
                    }
                    if (this.$refs['widthhandle-l']) {
                        this.$refs['widthhandle-l'].style.display = 'block';
                    }
                } else {
                    if (this.$refs['widthhandle-r']) {
                        this.$refs['widthhandle-r'].style.display = 'none';
                    }
                    if (this.$refs['widthhandle-l']) {
                        this.$refs['widthhandle-l'].style.display = 'none';
                    }
                }

                corners.forEach((corner) => {
                    const cornerGuide = this.$refs[corner] ? interact(this.$refs[corner]) : null;
                    if ((this.sizeable || this.rotateable) && cornerGuide) {
                        this.configureSizeInteract(
                            component,
                            cornerGuide,
                            this.$refs[corner],
                            false,
                            true,
                            0,
                            corner.includes('-r'),
                            corner.includes('width'),
                            !corner.includes('width'),
                        );
                    }
                });

                const rotateHandle = this.$refs.rotatehandle ? interact(this.$refs.rotatehandle) : null;
                if ((this.sizeable || this.rotateable) && rotateHandle) {
                    this.configureSizeInteract(component, rotateHandle, this.$refs.rotatehandle, true, false, -90, false, true, true);
                }

                this.interact = true;
            },

            configureSizeInteract(component, handle, el, canRotate, canSize, rotateOffset, rightSide, lockSize, lockWidth) {
                handle.draggable({
                    onstart: (event) => {
                        this.setActive(true);

                        this.captureX = null;
                        this.captureY = null;

                        if (this.placement) {
                            const { x: thumbX, y: thumbY } = this.getCenter(el);

                            this.thumbX = thumbX;
                            this.thumbY = thumbY;

                            const { scaleY, rotate } = this.getScaleRotation(
                                event.pageX - event.x0,
                                event.pageY - event.y0,
                                rotateOffset,
                                true,
                                canRotate,
                                lockSize,
                                lockWidth,
                            );

                            let rotateNow;
                            let scaleNow;

                            this.boxCenterX = 0;
                            this.boxCenterY = 0;
                            this.anchorX = 0;
                            this.anchorY = 0;

                            if (component.custom['widget-type'] === 'personalization') {
                                scaleNow = +((component.custom && component.custom['personalization-scale']) || '1');
                                rotateNow = +((component.custom && component.custom['personalization-rotate']) || '0');
                            } else {
                                scaleNow = +((component.custom && component.custom['dynamic-image-scale']) || '1');
                                rotateNow = +((component.custom && component.custom['dynamic-image-rotate']) || '0');
                            }

                            if (canSize) {
                                this.progressScaleStart = scaleNow || 1;
                                this.progressScale = (this.sizeable && canSize) ? (scaleY * this.progressScaleStart) : 1;

                                if (component.custom['widget-type'] === 'personalization') {
                                    this.progressRightSide = rightSide;
                                    this.progressBoxWidth = +(component.custom['personalization-width']);
                                    this.progressBoxHeight = +(component.custom['personalization-height']);
                                    this.progressBoxX = +(component.custom['personalization-x']);
                                    this.progressBoxY = +(component.custom['personalization-y']);
                                    this.progressBoxRotate = (+(component.custom['personalization-rotate']) * Math.PI) / 180;
                                    this.progressBoxAlign = component.custom['personalization-alignment'];
                                }
                            }

                            if (canRotate) {
                                this.progressRotateStart = rotateNow || 0;
                                this.progressRotate = (this.rotateable && canRotate) ? rotate : rotateNow;
                            }
                        }
                    },

                    onend: () => {
                        this.setActive(false);

                        if (this.placement) {
                            if (this.progressScale != null || this.progressRotate != null) {
                                // Commit changes.
                                const scale = this.progressScale;
                                const rotate = this.progressRotate;

                                this.progressScale = null;
                                this.progressRotate = null;

                                if (this.rotateable && canRotate) {
                                    if (component.custom['widget-type'] === 'personalization') {
                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'personalization-rotate': rotate.toString(),
                                        }, {
                                            propagate: true,
                                        });
                                    } else {
                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'dynamic-image-rotate': rotate.toString(),
                                        });
                                    }
                                }

                                if (this.sizeable && canSize) {
                                    if (component.custom['widget-type'] === 'personalization') {
                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'personalization-scale': scale.toString(),
                                        }, {
                                            propagate: true,
                                        });
                                    } else {
                                        this.controller.commitCustomAttributes(this.placement.placement.code, {
                                            'dynamic-image-scale': scale.toString(),
                                        });
                                    }
                                }

                                // Whoever cares about this stuff moving around might be very far in the Vue hierarchy
                                // so we will use the global notification bus instead.
                                this.$store.dispatch('layoutMoved', {
                                    placement: this.placement.placement,
                                    component,
                                });
                            }

                            this.cancelPaint();
                        }
                    },

                    onmove: (event) => {
                        if (this.placement) {
                            const { scaleX: calculatedScaleX, scaleY: calculatedScaleY, rotate } = this.getScaleRotation(
                                event.pageX - event.x0,
                                event.pageY - event.y0,
                                rotateOffset,
                                false,
                                canRotate,
                                lockSize,
                                lockWidth,
                            );

                            if (this.sizeable && canSize) {
                                // Adjust vertical scaling...
                                let scale = calculatedScaleY * this.progressScaleStart;

                                if (scale < 0.01) {
                                    scale = 0.01;
                                }

                                if (component.custom['widget-type'] === 'personalization') {
                                    // ... either via a font size
                                    let minSize = component.custom['v-personalization-size-min'];

                                    if (minSize != null) {
                                        minSize = +minSize;
                                        const size = +component.custom['personalization-size'];

                                        const currentSize = scale * size;

                                        if (currentSize < minSize) {
                                            const fitScale = minSize / size;

                                            this.progressScale = fitScale;

                                            this.$store.dispatch('toast', {
                                                message: this.$t('DRAG_MIN_TEXT_SIZE'),
                                                type: 'error',
                                            });
                                        } else {
                                            this.progressScale = scale;
                                        }
                                    } else {
                                        this.progressScale = scale;
                                    }

                                    // Also adjust the box width.
                                    const scaleX = calculatedScaleX;
                                    // Scale by the horizontal factor.
                                    let boxWidth = this.progressBoxWidth * (1 + (scaleX - 1) * 0.5);
                                    const minBoxWidth = +(component.custom['personalization-min-width']);
                                    if (boxWidth < minBoxWidth) {
                                        boxWidth = minBoxWidth;
                                    }

                                    // Redistribute the increased width along the box rotation axis.
                                    const deltaWidth = boxWidth - this.progressBoxWidth;
                                    let boxXAxis = Math.cos(this.progressBoxRotate);
                                    let boxYAxis = Math.sin(this.progressBoxRotate);

                                    let x = this.progressBoxX;
                                    let y = this.progressBoxY;

                                    const align = component.custom['personalization-alignment'] || 'center';

                                    if (rightSide) {
                                        // Nothing to do
                                    } else {
                                        x -= boxXAxis * deltaWidth;
                                        y -= boxYAxis * deltaWidth;
                                    }

                                    // Scale by the vertical factor since that affects the font size and thus the width as well.
                                    const beforeFontScaleWidth = boxWidth;
                                    boxWidth *= (scale / this.progressScaleStart);
                                    boxXAxis = 1;
                                    boxYAxis = 0;

                                    const deltaFontWidth = boxWidth - beforeFontScaleWidth;

                                    if (align === 'center') {
                                        x -= boxXAxis * deltaFontWidth * 0.5;
                                        y -= boxYAxis * deltaFontWidth * 0.5;
                                    }

                                    if (align === 'left') {
                                        // Nothing to do here.
                                    }

                                    if (align === 'right') {
                                        x -= boxXAxis * deltaFontWidth;
                                        y -= boxYAxis * deltaFontWidth;
                                    }

                                    const boxHeight = this.progressBoxHeight * (scale / this.progressScaleStart);
                                    const deltaFontHeight = boxHeight - this.progressBoxHeight;

                                    const vAlign = component.custom['personalization-vertical-alignment'] || 'center';

                                    if (vAlign === 'center') {
                                        x -= (-boxYAxis) * deltaFontHeight * 0.5;
                                        y -= (boxXAxis) * deltaFontHeight * 0.5;
                                    }

                                    if (vAlign === 'top') {
                                        // Nothing to do here.
                                    }

                                    if (vAlign === 'bottom') {
                                        x -= (-boxYAxis) * deltaFontHeight;
                                        y -= (boxXAxis) * deltaFontHeight;
                                    }

                                    this.placement.placement.components.forEach((c) => {
                                        c.custom['personalization-x'] = x.toString();
                                        c.custom['personalization-y'] = y.toString();
                                        c.custom['personalization-width'] = boxWidth.toString();
                                        c.custom['personalization-height'] = boxHeight.toString();
                                    });
                                } else {
                                    // ... or through the image size.
                                    const componentWidth = (+((component.custom && component.custom['dynamic-image-width']) || '0'));
                                    const componentHeight = (+((component.custom && component.custom['dynamic-image-height']) || '0'));
                                    const minExtent = (+((component.custom && component.custom['v-dynamic-image-min-extent']) || '450'));

                                    const scaleWidth = componentWidth * scale < minExtent ? (minExtent / componentWidth) : scale;
                                    const scaleHeight = componentHeight * scale < minExtent ? (minExtent / componentHeight) : scale;

                                    const adjustedScale = Math.min(scaleWidth, scaleHeight);

                                    this.progressScale = adjustedScale;
                                }
                            }

                            if (this.rotateable && canRotate) {
                                this.progressRotate = rotate;
                            }

                            this.paint();
                        }
                    },
                })
                    .styleCursor(false);
            },

            /**
             * Gets document-relative coordinates of the element's center, post all transforms.
             */
            getCenter(el, captureX, captureY) {
                const rect = el.getBoundingClientRect();

                let x = window.scrollX + rect.left + (rect.width * 0.5);
                let y = window.scrollY + rect.top + (rect.height * 0.5);

                if (captureX != null) {
                    x = captureX;
                }

                if (captureY != null) {
                    y = captureY;
                }

                let angle = 0;

                const { component } = this.placement;

                if (component.custom['widget-type'] === 'personalization') {
                    angle = +(component.custom['personalization-rotate'] || '0');
                }

                if (component.custom['widget-type'] === 'dynamic-image') {
                    angle = +(component.custom['dynamic-image-rotate'] || '0');
                }

                const r = (angle * Math.PI) / 180;
                const nx = Math.cos(r);
                const ny = Math.sin(r);

                return {
                    x,
                    y,
                    r,
                    nx,
                    ny,
                };
            },

            /**
             * Calcuates scale and rotation based on the difference from the gizmo center.
             */
            getScaleRotation(offsetX, offsetY, rotateOffset, captureStart, rotating, blockSize, blockWidth) {
                const {
                    x: centerX,
                    y: centerY,
                    nx,
                    ny,
                } = this.getCenter(this.$refs.sizeguide, this.captureX, this.captureY);

                if (captureStart) {
                    this.captureX = centerX;
                    this.captureY = centerY;
                }

                const dx = (this.thumbX + offsetX) - centerX;
                const dy = (this.thumbY + offsetY) - centerY;

                // Rotation only.
                if (rotating) {
                    const r = Math.sqrt((dx * dx) + (dy * dy));

                    const ndx = dx / r;
                    const ndy = dy / r;

                    let rotate = (Math.atan2(ndy, ndx) * 180) / Math.PI;

                    if (rotateOffset != null) {
                        rotate += rotateOffset;
                    }

                    // Apply snapping at angles close to 90 degrees.
                    const snapped = Math.round(rotate / constants.SNAP_ANGLE) * constants.SNAP_ANGLE;

                    if (Math.abs(snapped - rotate) < constants.SNAP_TOLERANCE) {
                        rotate = snapped;
                    }

                    return {
                        rotate,
                        scaleX: 1,
                        scaleY: 1,
                    };
                }

                if (this.placement.component.custom['widget-type'] === 'personalization' && !blockSize && blockWidth) {
                    const r = Math.sqrt((dx * dx) + (dy * dy));

                    let scale;

                    if (captureStart) {
                        this.startRadius = r;
                        scale = 1;
                    } else {
                        scale = r / this.startRadius;
                    }

                    return {
                        rotate: rotateOffset == null ? 0 : rotateOffset,
                        scaleX: 1,
                        scaleY: scale,
                    };
                }

                // Propotional scale on both axis at the same time.
                if (this.placement.component.custom['widget-type'] === 'dynamic-image') {
                    const r = Math.sqrt((dx * dx) + (dy * dy));

                    let scale;

                    if (captureStart) {
                        this.startRadius = r;
                        scale = 1;
                    } else {
                        scale = r / this.startRadius;
                    }

                    const scaleMin = +(this.placement.component.custom['dynamic-image-scale-min'] || '0.1');
                    const scaleMax = +(this.placement.component.custom['dynamic-image-scale-max'] || '5');

                    scale = Math.min(scaleMax, Math.max(scaleMin, scale));

                    return {
                        rotate: rotateOffset == null ? 0 : rotateOffset,
                        scaleX: scale,
                        scaleY: scale,
                    };
                }

                // Separate scaling on the x and y axis.
                const widthX = ((dx * nx + dy * ny) / (nx * nx + ny * ny)) * nx;
                const widthY = ((dx * nx + dy * ny) / (nx * nx + ny * ny)) * ny;
                // eslint-disable-next-line prefer-const
                let dWidth = Math.sqrt(widthX * widthX + widthY * widthY);

                const nyHeight = nx;
                const nxHeight = -ny;

                const heightX = ((dx * nxHeight + dy * nyHeight) / (nxHeight * nxHeight + nyHeight * nyHeight)) * nxHeight;
                const heightY = ((dx * nxHeight + dy * nyHeight) / (nxHeight * nxHeight + nyHeight * nyHeight)) * nyHeight;
                // eslint-disable-next-line prefer-const
                let dHeight = Math.sqrt(heightX * heightX + heightY * heightY);

                let lockWidth = false;
                if (this.controller.blueprint.custom['no-box-sizing'] === 'true') {
                    lockWidth = true;
                }

                if (this.placement.placement.code.startsWith(constants.PLACEMENT_MONOGRAM)) {
                    lockWidth = true;
                }

                if (blockWidth) {
                    lockWidth = true;
                }

                if (lockWidth) {
                    dWidth = 1;
                }

                let lockHeight = false;

                if (blockSize) {
                    lockHeight = true;
                }

                if (lockHeight) {
                    dHeight = 1;
                }

                let scaleX;
                let scaleY;

                if (captureStart) {
                    this.startNdx = dWidth;
                    this.startNdy = dHeight;
                    scaleX = 1;
                    scaleY = 1;
                } else {
                    scaleX = Math.abs(dWidth / this.startNdx);
                    scaleY = Math.abs(dHeight / this.startNdy);
                }

                const scaleMin = 0.1;
                const scaleMax = 5;

                scaleX = Math.min(scaleMax, Math.max(scaleMin, scaleX));
                scaleY = Math.min(scaleMax, Math.max(scaleMin, scaleY));

                return {
                    scaleX,
                    scaleY,
                    rotate: rotateOffset == null ? 0 : rotateOffset,
                };
            },

            /**
             * Called whenever controller state change happens.
             * @return {void}
             */
            onStateChanged() {
                if (this.placement) {
                    // Reload dynamic image of the placement had changed.
                    const image = this.placement.component.custom && this.placement.component.custom['dynamic-image-jpgUrl'];

                    if (!this.image || this.image.url !== image) {
                        this.selectView();
                    }
                }

                this.paint();
            },

            /**
             * Called whenever controller requests explicit repaint.
             * @return {void}
             */
            onRepaint() {
                this.paint();
            },

            cancelPaint() {
                if (this.paintTimer) {
                    cancelAnimationFrame(this.paintTimer);
                }
            },

            /**
             * Debounce paint requests.
             */
            paint() {
                if (this.paintTimer) {
                    cancelAnimationFrame(this.paintTimer);
                }

                this.paintTimer = requestAnimationFrame(this.paintDebounced);
            },
        },
    };
</script>
